// Founder image slots. Image blocks on /founders are hidden until set
// — no stock photos, no captioned placeholders on the public site.
//
// FOUNDER TO SUPPLY: drop image files into `src/assets/founders/` and
// switch the relevant `null` below to an import. Examples once a file
// is added:
//
//   import sakshiPortrait from "@/assets/founders/sakshi.jpg";
//   export const sakshi = sakshiPortrait;
//
//   import candid01 from "@/assets/founders/candid-01.jpg";
//   import candid02 from "@/assets/founders/candid-02.jpg";
//   export const candids = [candid01, candid02];

export const sakshi = null;
export const shailendra = null;
export const candids = [];
